import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { apiRequest, assetUrl, formatPrice } from "../api/client";
import Button from "../components/Button";
import EmptyState from "../components/ui/EmptyState";
import LoadingSpinner from "../components/ui/LoadingSpinner";
import { useCart } from "../context/CartContext";
import { useToast } from "../context/ToastContext";
import fallbackCover from "../assets/Ebook.png";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const cart = useCart();
  const toast = useToast();

  useEffect(() => {
    apiRequest("/api/products")
      .then((response) => setProducts(response.data))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  const filtered = products.filter((product) => product.name.toLowerCase().includes(search.toLowerCase()));

  if (loading) return <section className="section"><LoadingSpinner label="Loading products" /></section>;

  return (
    <section className="section shop-page">
      <div className="container">
        <div className="shop-head">
          <div>
            <span className="eyebrow">Digital store</span>
            <h1>Nutrition eBooks</h1>
            <p>Science-based digital products built for serious physique progress.</p>
          </div>
          <label className="shop-search">
            <span>Search</span>
            <input value={search} onChange={(event) => setSearch(event.target.value)} placeholder="Find a product" />
          </label>
        </div>

        {error && <p className="form-status error">{error}</p>}
        {!filtered.length ? (
          <EmptyState title="No products found" text="Try a different search or check back soon." />
        ) : (
          <div className="shop-grid">
            {filtered.map((product) => (
              <motion.article className="shop-card glass-card" key={product.id} whileHover={{ y: -8 }}>
                <Link to={`/products/${product.slug}`} className="shop-card-image">
                  <img src={assetUrl(product.image_url, fallbackCover)} alt={product.name} />
                  {product.featured && <span>Featured</span>}
                </Link>
                <div className="shop-card-copy">
                  <small>{product.category}</small>
                  <h3>{product.name}</h3>
                  <p>{product.short_description}</p>
                  <div className="price-row">
                    <span>{formatPrice(product.discount_price || product.price)}</span>
                    {product.discount_price && <s>{formatPrice(product.price)}</s>}
                  </div>
                  <div className="shop-card-actions">
                    <Button to={`/products/${product.slug}`} variant="secondary">Details</Button>
                    <Button onClick={() => {
                      cart.add(product);
                      toast?.show("Added to cart.");
                    }}>Add to Cart</Button>
                  </div>
                </div>
              </motion.article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
